<template>
  <div>
    <form-filtered-select
      :selected-key="selectedLinehaulRoad ? selectedLinehaulRoad.value : null"
      :options="linehaulRoadOptions"
      :invalid="invalid"
      placeholder="Linehaul Road"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedLinehaulRoad: null
    }
  },
  computed: {
    ...mapGetters('linehaulRoad', ['linehaulRoadOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedLinehaulRoad && this.value.value !== this.selectedLinehaulRoad.value) {
        this.selectedLinehaulRoad = this.value
      }
    }
  },
  mounted () {
    this.selectedLinehaulRoad = this.value
    this.$watch('selectedLinehaulRoad', function () {
      this.$emit('input', this.selectedLinehaulRoad)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedLinehaulRoad = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
